import { Box, BoxProps, SkipNavContent, SkipNavLink } from '@chakra-ui/react';
import React from 'react';

import { MobileSubNav } from '../sidebar/sidebar.sm';

const App = ({ children, ...rest }: BoxProps) => (
  <Box h="100vh" {...rest}>
    {children}
  </Box>
);
const AppBody = ({ children, ...rest }: BoxProps) => (
  <Box h="100%" overflow="auto" {...rest}>
    {children}
  </Box>
);
const AppContent = ({ children, ...rest }: BoxProps) => (
  <Box height="calc(100% - 3rem)" overflow="auto" {...rest}>
    {children}
  </Box>
);

export const AppLayoutSm = (props: { children: React.ReactNode }): React.ReactNode => {
  return (
    <>
      <SkipNavLink zIndex={9999}>Skip to content</SkipNavLink>

      <App>
        <Box>
          <MobileSubNav initialDrawerOpen={false} />
        </Box>
        <AppBody px={4} w="100%" pb={4}>
          <SkipNavContent />
          <AppContent>{props.children}</AppContent>
        </AppBody>
        {/* <AppPopups />
        <AppDrawers /> */}
      </App>
    </>
  );
};

export default AppLayoutSm;
